const allowSymbols = function(str) {
  return /^[^<>=]*$/.test(str)
}

const likePhone = function(str) {
  return /[0-9()\-\+\s]*/.test(str)
}

const likeEmail = function(str) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str)
}

const phoneOverlong = function(str) {
  if (str) {
    return str.length <= 16
  }
  return true
}

const emailOverlong = function(str) {
  if (str) {
    return str.length <= 128
  }
  return true
}

const notIn = function(str, list = []) {
  return list.indexOf(str) === -1
}

const safePass = function(str) {
  return /^(?=.*[a-z])(?=.*[0-9])[^.]{8,}$/i.test(str)
}

const heightMoreThanWeight = function(_value, obj) {
  let bodyMassIndex = (+obj.weight / (+obj.height * +obj.height)) * 100
  if (bodyMassIndex > 1.1) return false
  else return true
}
const heightLess300 = function(value) {
  if (+value > 250) return false
  else return true
}
const weightLess300 = function(value) {
  if (+value > 300) return false
  else return true
}

export {
  allowSymbols,
  likePhone,
  likeEmail,
  phoneOverlong,
  emailOverlong,
  notIn,
  safePass,
  heightMoreThanWeight,
  heightLess300,
  weightLess300
}
